// SidingBoards recipe — Buildings Set1 §7.4: horizontal lap siding with a shadow line under each
// lap. Doubles as a wood-floor plank with a different axis. Uses the new `siding` primitive.
// Immutable built-in root.
import {MaterialLayer, MaterialRecipe, ParamSchema} from "../@MaterialTypes.js";

export const SIDING_BOARDS_RECIPE_ID = "sidingBoards";

export const sidingBoardsRecipe = new MaterialRecipe({
	id: SIDING_BOARDS_RECIPE_ID,
	name: "Siding boards",
	roughness: 0.6,
	specStrength: 0.05,

	params: [
		new ParamSchema({key: "board_height", label: "Board height (m)", kind: "scalar", min: 0.05, max: 1, default: 0.15}),
		new ParamSchema({key: "lap_overlap", label: "Lap overlap (m)", kind: "scalar", min: 0, max: 0.3, default: 0.02}),
		new ParamSchema({key: "shadow_depth", label: "Lap shadow (m)", kind: "scalar", min: 0, max: 0.02, default: 0.004}),
		new ParamSchema({key: "board_ramp", label: "Board ramp", kind: "ramp", default: [0, 0.62, 0.54, 0.42, 0.4, 0.7, 0.62, 0.5, 0.75, 0.78, 0.7, 0.56, 1, 0.66, 0.58, 0.46]}),
		new ParamSchema({key: "gap_color", label: "Gap colour", kind: "color", default: [0.1, 0.09, 0.08]}),
	],
	layers: [
		new MaterialLayer({
			id: "laps",
			primitive: "siding",
			args: {
				boardHeight: {ref: "board_height"},
				lapOverlap: {ref: "lap_overlap"},
				shadowDepth: {ref: "shadow_depth"},
				boardRamp: {ref: "board_ramp"},
				gapColor: {ref: "gap_color"},
			},
			blend: "over",
			contributes: "both",
		}),
	],
});
